import { get,post } from '@/utils/axios'

export default {
    
    // 管理登录
    loginAdmin(datas){
        return get('AdminUser/Login',datas)
    },
    sendCode(datas){
        return get('OAuth/SendCode',datas)
    },
    getImageCode(datas){
        return get('OAuth/GetImageCode')
    },
}